<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-card
    class="pa-2 d-flex flex-column justify-center"
    color="grey lighten-5"
    elevation="0"
    style="position:relative"
    tile
  >
    <div
      class="text-body-2 font-weight-bold"
      style="position: absolute;top:16px"
    >
      {{ $t('AveragedNetProfitPerDay') }}
    </div>
    <apex-chart
      v-if="graphIsReady"
      :options="options"
      :series="series"
      height="350"
      type="bar"
      width="100%"
    />
  </v-card>
</template>
<script>
import dayjs from 'dayjs'

export default {
  name: 'DaliyWinLostChart',
  props: {
    totalCost: {},
    dailyInfo: {}
  },
  data: function () {
    return {
      series: [],
      options: {},
      graphIsReady: false
    }
  },
  mounted () {
    this.initGraph()
  },
  methods: {
    initGraph: async function () {
      this.graphIsReady = false
      const data = this.dailyInfo.map(it => {
        const value = (it.orderInfo.totalTotalPrice - (this.totalCost / dayjs().daysInMonth())).toFixed(2)
        return {
          x: it.date,
          y: value,
          fillColor: value > 0 ? '#fbdc46' : '#8a8a8a'
        }
      })
      console.log(data)
      this.series = [
        {
          data
        }
      ]

      this.options = {
        fill: {
          colors: [
            '#8a8a8a',
            '#3a3a3a',
            '#bababa',
            '#fbdc46'
          ]
        },
        yaxis: {
          show: false
        },
        plotOptions: {
          area: {
            fillTo: 'end'
          }
        },
        chart: {
          sparkline: {
            enabled: true
          }
        },
        grid: {
          show: false
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: true
        },
        xaxis: {
          type: 'category',
          labels: {
          },
          axisTicks: {
            show: false
          }
        }

      }
      this.graphIsReady = true
    }
  }
}
</script>

<style scoped>

</style>
